import { RandomId, StringHelper } from "@swivl-mono/helpers";
import { NodeData_ArrayPicker, NodeData_Increment, NodeInterface, NodeType } from "@swivl-mono/types";
import { Checkbox, Switch } from "@swivl-mono/ui";

import UserVariablesDropdown from "../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import VarsModel from "../../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData, { TabNodePositionalData } from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const ArrayPickerNode = {
  Type: NodeType.ArrayPicker,
  Empty: function () {
    return {
      id: RandomId(6),
      type: NodeType.ArrayPicker,
      shouldPickOnlyItemAutomatically: true,
      onPickedGoto: "",
      onlyItemAutomaticallyPickedGoto: "",
      noItemsGoto: ""
    } as NodeData_ArrayPicker;
  },

  PlumbData: function (node: NodeInterface) {
    const variable = node.variableId && node.variableId.length ? "#*" + node.variableId + "*#" : "Unset";
    let title = StringHelper.trimStringToLengthWithElipsis(VarsModel.replaceVariableNameInString(variable), 20);

    let tabs = node.shouldPickOnlyItemAutomatically
      ? [
          { title: "Item Picked", id: "onPickedGoto", source: "onPickedGoto", target: node.onPickedGoto },
          { title: "No Items", id: "noItemsGoto", source: "noItemsGoto", target: node.noItemsGoto },
          {
            title: "Only Item Picked",
            id: "onlyItemAutomaticallyPickedGoto",
            source: "onlyItemAutomaticallyPickedGoto",
            target: node.onlyItemAutomaticallyPickedGoto
          }
        ]
      : [
          { title: "Item Picked", id: "onPickedGoto", source: "onPickedGoto", target: node.onPickedGoto },
          { title: "No Items", id: "noItemsGoto", source: "noItemsGoto", target: node.noItemsGoto }
        ];

    if (node.unhandledOutput) {
      tabs.push({
        id: "unhandledOutput",
        source: "unhandledOutput_goto",
        target: node.unhandledOutput.goto,
        title: "Unhandled"
      });
    }

    return TabNodeLayoutData({
      node: node,
      label: "Array Picker",
      title: title,
      body: "",
      titleHeight: 45,
      baseWidth: 150,
      tabs: tabs
    });
  },

  InspectorPanel: class IncrementInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.toggleUnhandledOutput = this.toggleUnhandledOutput.bind(this);
    }

    toggleUnhandledOutput(e: any) {
      const on = e.target.value;
      let node = JSON.parse(JSON.stringify(this.props.node));
      if (on) {
        node.unhandledOutput = {
          id: "unhandledOutput",
          goto: null
        };
      } else {
        delete node.unhandledOutput;
      }
      this.props.updateNode(node, this.props.node, true);
    }

    render() {
      const node = this.props.node as NodeData_ArrayPicker;

      return (
        <div>
          <div className="panel TableSaveRowPanel">
            <InspectorNodeHeader title="Array Picker" id={node.id} />
            <label>Array Variable</label>
            <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name="variableId" value={node.variableId} skipBotVariables={true} />

            <label>Set Selected Item To Variable</label>
            <UserVariablesDropdown
              onChange={this.onChange}
              skipUserId={true}
              name="setToVariableId"
              value={node.setToVariableId}
              skipBotVariables={true}
            />

            <Checkbox
              checked={this.props.node.shouldPickOnlyItemAutomatically}
              label="Automatically Pick if there is only one"
              name={"shouldPickOnlyItemAutomatically"}
              onCheckedChange={(checked) => this.onChangeSwitch("shouldPickOnlyItemAutomatically", checked)}
            />

            <div className="row">
              <div className="col-8">
                <label>Unhandled Output</label>
              </div>
              <div className="col-4">
                <Switch onChange={this.toggleUnhandledOutput} on={this.props.node.unhandledOutput ? true : false} />
              </div>
            </div>

            <InspectorFooter
              deleteNode={this.deleteNode}
              node={this.props.node}
              duplicateNode={this.props.duplicateNode}
              canDuplicate={this.props.canDuplicate}
            />
          </div>
        </div>
      );
    }
  }
};
export default ArrayPickerNode;
